/**
 * @module components/theme/Forbidden/Forbidden
 */
import Cookies from 'universal-cookie';
import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Container, Form, Button } from 'semantic-ui-react';
import { withServerErrorCode } from '@plone/volto/helpers/Utils/Utils';
import { getBaseUrl } from '@plone/volto/helpers/Url/Url';
import { getCookieOptions } from '@plone/volto/helpers/Cookies/cookies';
import CryptoJS from 'crypto-js';

const Forbidden = (props) => {
  const [pathKeyInput, setPathKeyInput] = useState('');
  const [data, setData] = useState(null);

  const location = useLocation();

  useEffect(() => {
    setData(props?.error?.response?.body);
  }, [props?.error?.response?.body]);

  const handlePathKeyInputChange = (e) => {
    setPathKeyInput(e.target.value);
  };

  const handleSubmit = (e) => {
    // Compute a cookie hash based on input
    const hashedPathKey = CryptoJS.MD5(pathKeyInput).toString();
    // Set the cookie
    const cookies = new Cookies();
    cookies.set('path_key', hashedPathKey, getCookieOptions());
    // Redirect the user to the original destination.
    window.location.href =
      getBaseUrl(location.pathname) + window.location.search;
  };

  return (
    <Container className="view-wrapper">
      <h1>
        <FormattedMessage id="Forbidden" defaultMessage="Forbidden" />
      </h1>
      {data?.error !== 'PathKeyRequired' ? (
        <p className="description">
          <FormattedMessage
            id="We apologize for the inconvenience, but you don't have permissions on this resource."
            defaultMessage="We apologize for the inconvenience, but you don't have permissions on this resource."
          />
        </p>
      ) : (
        <p className="description">
          <FormattedMessage
            id="requiredPathKey"
            defaultMessage="A pathkey is required to access this resource."
          />
        </p>
      )}
      {data?.pathkey_owner && (
        <p>
          <FormattedMessage id="pathKeyOwner" defaultMessage="Pathkey owner:" />{' '}
          {data.pathkey_owner}
        </p>
      )}
      {data?.pathkey_owner_email && (
        <p>
          <FormattedMessage
            id="pathKeyOwnerEmail"
            defaultMessage="You can request the correct pathkey by emailing:"
          />{' '}
          <a href={`mailto:${data.pathkey_owner_email}`}>
            {data.pathkey_owner_email}
          </a>
        </p>
      )}
      {data?.pathkey && (
        <p>
          <FormattedMessage id="pathKeyDisplay" defaultMessage="Pathkey is:" />{' '}
          <strong>{data.pathkey}</strong>
        </p>
      )}
      {data?.error === 'PathKeyRequired' && (
        <Form onSubmit={handleSubmit}>
          <Form.Field>
            <label htmlFor="pathkey-input">
              <FormattedMessage
                id="pathKeyLabel"
                defaultMessage="Enter your pathkey"
              />
            </label>
            <input
              id="pathkey-input"
              type="text"
              value={pathKeyInput}
              onChange={handlePathKeyInputChange}
              required
            />
          </Form.Field>
          <Button type="submit">
            <FormattedMessage
              id="pathkeySubmitButton"
              defaultMessage="Submit"
            />
          </Button>
        </Form>
      )}
    </Container>
  );
};

export default withServerErrorCode(403)(Forbidden);
